<template>
    <span class="hero-shape-4">
        <svg width="1580.29502px" height="1665px" viewBox="0 0 1580.29502 1665" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <radialGradient cx="40.4779071%" cy="61.0746726%" fx="40.4779071%" fy="61.0746726%" r="74.8836909%" gradientTransform="translate(0.4048, 0.6107), scale(1, 0.9379), rotate(104.018), scale(1, 0.85), translate(-0.4048, -0.6107)" id="radialGradient-j8250o2m-q-1">
                    <stop stop-color="#F26363" offset="0%"></stop>
                    <stop stop-color="#F26363" stop-opacity="0" offset="100%"></stop>
                </radialGradient>
                <filter x="-11.7%" y="-11.0%" width="123.4%" height="122.0%" filterUnits="objectBoundingBox" id="filter-j8250o2m-q-2">
                    <feGaussianBlur stdDeviation="50" in="SourceGraphic"></feGaussianBlur>
                </filter>
            </defs>
            <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Bg/Home-Hero" transform="translate(-446.0118, 607.8984)" fill="url(#radialGradient-j8250o2m-q-1)">
                    <path d="M1456.39676,-191.556513 C1755.75135,-18.9621755 1990.67532,-11.9651078 1817.20825,244.594043 C1643.74119,501.153194 891.058056,1045.77505 673.316853,874.33014 C455.575651,702.885231 748.651122,-439.952418 927.074391,-456.27891 C1105.49766,-472.605401 1157.04216,-364.150851 1456.39676,-191.556513 Z" id="Hero-Shape_4" filter="url(#filter-j8250o2m-q-2)"></path>
                </g>
            </g>
        </svg>
    </span>
</template>
